import { IkasImage } from "../image";
import { IkasMerchantAddress } from "./address";

export type IkasMerchantSettings = {
  address: IkasMerchantAddress | null;
  currencyFormats: IkasMerchantSettingsCurrencyFormat[] | null;
  logoId: string | null;
  merchantId: string;
  merchantName: string;
  phone: string | null;

  // Extra
  logo?: IkasImage | null;
};

export type IkasMerchantSettingsCurrencyFormat = {
  currencyCode: string;
  decimalSeparator: string;
  symbol: string;
  symbolPosition: IkasMerchantSettingsCurrencyFormatSymbolPosition;
  thousandSeparator: string;
  omitZeroDecimal: boolean;
};

enum IkasMerchantSettingsCurrencyFormatSymbolPosition {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
